import React, { useState, useRef, ReactNode } from 'react';
import { DropdownPortal } from './DropdownPortal';
import { Stack } from '@primer/react';

interface GenericDropdownModalProps {
    children: (onClose: () => void) => ReactNode;
    triggerContent: ReactNode;
    isLoading?: boolean;
    disabled?: boolean;
    containerClassName?: string;
    triggerClassName?: string;
}

const SectionSelector: React.FC<GenericDropdownModalProps> = ({
    children,
    triggerContent,
    isLoading = false,
    disabled = false,
    containerClassName = '',
    triggerClassName = ''
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const triggerRef = useRef<HTMLButtonElement>(null);

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <button
                ref={triggerRef}
                onClick={handleToggle}
                disabled={disabled || isLoading}
                className={`w-full h-[40px] p-0 ${disabled ? "bg-aloix-disabled border-[#818B981A]" : "bg-white border-border"} border rounded-lg mx-auto flex items-center justify-center px-4 ${triggerClassName}`}
            >
                <Stack direction="horizontal" align="center" className='w-full'>
                    <div className="flex items-center w-full gap-4 overflow-hidden">
                        {triggerContent}
                    </div>
                    <img
                        alt="arrows"
                        src="/icons/caret.png"
                        className="w-4 h-4"
                    />
                </Stack>
            </button>

            <DropdownPortal isOpen={isOpen} onClose={handleClose} triggerRef={triggerRef}>
                <div className={containerClassName}>
                    {children(handleClose)}
                </div>
            </DropdownPortal>
        </>
    );
};

export default SectionSelector;